import colors from "../base/colors";
import rgba from "../functions/rgba";

const { secondary } = colors;
const appBar = {
  defaultProps: {
    background: "#fff",
  },

  styleOverrides: {
    root: {
      background: rgba(secondary.main, 0.3),
      
    },
  },
};

export default appBar;
